export default [
  {
    name: 'Admin Dashboard',
    icon: 'now-ui-icons education_atom',
    path: '/dashboard/admin',
    roles: ['admin']
  },
  {
    name: 'Teacher Dashboard',
    icon: 'now-ui-icons objects_planet',
    path: '/dashboard/teacher',
    roles: ['teacher']
  },
  {
    name: 'Student Dashboard',
    icon: 'now-ui-icons objects_planet',
    path: '/dashboard/student',
    roles: ['student','admin']
  },
  {
    name: 'Users',
    icon: 'now-ui-icons users_circle-08',
    roles: ['admin'],
    children: [
      {
        name: 'Teachers',
        path: '/users/teachers',
        roles: ['admin'],
      },
      {
        name: 'Students',
        path: '/users/students',
        roles: ['admin'],
      },
    ]
  },
  {
    name: 'Registrations',
    icon: 'now-ui-icons gestures_tap-01',
    roles: ['admin', 'student'],
    children: [
      {
        name: 'Programmes',
        path: '/programmes/list',
        roles: ['admin'],
      },
      // {
      //   name: 'Dashboard',
      //   path: '/programmes/dashboard',
      //   roles: ['admin'],
      // },
      // {
      //   name: 'Events',
      //   path: '/events',
      //   roles: ['admin'],
      // },
      {
        name: 'View',
        path: '/registrations/view',
        roles: ['student']
      }
    ]
  },
  {
    name: 'General Elective',
    icon: 'now-ui-icons files_paper',
    roles: ['admin'],
    children: [
      {
        name: 'Programmes',
        path: '/CBCS/courses',
        roles: ['admin'],
      },
      {
        name: 'Courses',
        path: '/CBCS/papers/manage',
        roles: ['admin'],
      },
    ]
  },
  {
    name: 'Circulars & News',
    icon: 'now-ui-icons education_paper',
    roles: ['admin', 'author'],
    children: [
      {
        name: 'News',
        path: '/glimpses/news',
        roles: ['admin', 'author'],
      },
      {
        name: 'Glimpses',
        path: '/glimpses/newsletters',
        roles: ['admin'],
      },
      {
        name: 'Notifications',
        path: '/glimpses/notifications',
        roles: ['admin'],
      },
      {
        name: 'Circulars',
        path: '/glimpses/notices/manage',
        roles: ['admin'],
      },
      {
        name: 'KJU Today',
        path: '/glimpses/today/manage',
        roles: ['admin'],
      },
    ]
  },
  {
    name: 'Reports',
    icon: 'now-ui-icons files_box',
    path: '/reports',
    roles: ['admin', 'teacher'],
    children: [
      // {
      //   name: 'All',
      //   path: '/reports/view',
      //   roles: ['admin', 'teacher'],
      // },
      {
        name: 'Subscriptions',
        path: '/reports/subscriptions',
        roles: ['admin', 'teacher'],
      },
    ]
  },
  // {
  //   name: 'Charts Demo',
  //   icon: 'now-ui-icons text_align-left',
  //   path: '/dashboard/charts',
  //   roles: ['admin', 'teacher', 'student']
  // },
  // {
  //   name: 'Activity Log',
  //   icon: 'now-ui-icons text_align-left',
  //   path: '/log',
  //   roles: ['student']
  // },
  {
    name: 'Settings',
    roles: ['admin', 'student'],
    icon: 'now-ui-icons ui-1_settings-gear-63',
    children: [
      {
        name: 'Roles',
        path: '/settings/roles',
        roles: ['admin'],
      },
      {
        name: 'Miscs',
        path: '/settings/miscs',
        roles: ['admin'],
      }
    ]
  },
]
